export enum ETier {
  ALPHA = "Alpha",
  BETA = "Beta",
  GAMMA = "Gamma",
  BEGINNER = "Beginner",
}

export const campaignIds = ["3ghuAYvu", "alphamind"];
